export default (value: string): boolean => {
	const re = /[^a-zA-Z0-9].*[^a-zA-Z0-9]/;
	return re.test(value);
};
